import * as auditLogApi from '../services/api/audit_logs';

export const AUDIT_LOGS_RECEIVED = 'AUDIT_LOGS_RECEIVED';
export const AUDIT_LOGS_LOADING_CHANGED = 'AUDIT_LOGS_LOADING_CHANGED';
export const AUDIT_LOGS_RESET = 'AUDIT_LOGS_RESET';

export function auditLogsRefreshed(logs, isMoreLogsToLoad) {
    return {
        type: AUDIT_LOGS_RECEIVED,
        logs,
        isMoreLogsToLoad
}
}

export function loadMoreAuditLogs(userId) {

    return (dispatch, getState) => {

        const logCount = getState().auditLogs.logs.length;

        dispatch(auditLogsLoadingChanged(true));

        return auditLogApi
            .getByUser(userId, { offset: logCount, limit: 10 })
            .then(res => {

                const isMoreToLoad = res.meta.total > logCount + res.payload.length;

                dispatch(auditLogsRefreshed(res.payload, isMoreToLoad));
                dispatch(auditLogsLoadingChanged(false));
            });
    }
}

export function auditLogsLoadingChanged(isLoading) {
    return {
        type: AUDIT_LOGS_LOADING_CHANGED,
        isLoading
    }
}

export function resetLogs() {
    return {
        type: AUDIT_LOGS_RESET
    }
}